module.exports = __webpack_public_path__ + "img/self-service-1.6ae186de.svg";